import React, { useEffect, useState } from "react";
import { assetti, esecuzioni, Esercizio, finalita, modalita, tipologia } from "../interfaces/Esercizio";

interface EsercizioDetailsTableProps {
  //token: string;
  esercizio: Esercizio;
}

export default function EsercizioDetailsTable({ esercizio }: EsercizioDetailsTableProps) {
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const image = esercizio.preview_image

  const getNameFromValue = (list: { value: string, name: string }[], value?: string) => {
    if (!value) return "-";
    const item = list.find(i => i.value === value);
    return item ? item.name : value;
  };

  useEffect(() => {
    if (!image) {
      setPreviewImage(null);
      return;
    }

    if (typeof image === "object") {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(image);
    }
    if (typeof image === "string") {
      const fetchFile = async (url: string) => {
        try {
          const headers = new Headers();
          //if (token) {
          //  headers.set('Authorization', `Token ${token}`);
          //}
          headers.set('Accept', 'application/json');
          const requestInit: RequestInit = {
            method: 'GET',
            headers: headers,
            credentials: 'include',
          }
          const response = await fetch(url, requestInit);
          const blob = await response.blob();
          const filetype = blob.type
          const file = new File([blob], 'file.' + filetype.split("/")[1], { type: filetype });
          setPreviewImage(url);
        } catch (error) {
          console.error('Errore durante il caricamento del file:', error);
        }
      };
      fetchFile(image);
    }
  }, [image]);


  return (

    <table className="table table-bordered rounded">
      <tbody>
        <tr>
          <th>Ultimo aggiornamento</th>
          <td></td>
        </tr>
        <tr>
          <th>Tipologia</th>
          <td>{getNameFromValue(tipologia, esercizio.type)}</td>
        </tr>
        <tr>
          <th>Preview</th>
          <td>{esercizio.preview_image ? <img
            src={previewImage ? previewImage : ""}
            alt="Preview"
            style={{ maxWidth: "200px", marginBottom: "1rem" }}
          /> : null}</td>
        </tr>
        <tr>
          <th>Nome corto</th>
          <td>{esercizio.full_name || "-"}</td>
        </tr>
        {esercizio.type != "SpotEducativo" &&
          <tr>
            <th>Nome vocale</th>
            <td>{esercizio.vocal_name || "-"}</td>
          </tr>
        }
        <tr>
          <th>Descrizione</th>
          <td>{esercizio.full_description || "-"}</td>
        </tr>
        {esercizio.type != "SpotEducativo" &&
          <tr>
            <th>Descrizione vocale</th>
            <td>{esercizio.vocal_description || "-"}</td>
          </tr>
        }
        <tr>
          <th>Posizione</th>
          <td>{esercizio.position || "-"}</td>
        </tr>
        <tr>
          <th>Finalità</th>
          <td>{getNameFromValue(finalita, esercizio.purpose)}</td>
        </tr>
        {esercizio.type != "SpotEducativo" && <>
          <tr>
            <th>Esecuzione</th>
            <td>{getNameFromValue(esecuzioni, esercizio.execution)}</td>
          </tr>
          <tr>
            <th>Modalità</th>
            <td>{getNameFromValue(modalita, esercizio.mode)}</td>
          </tr>
          <tr>
            <th>Comparto muscolare</th>
            <td>{esercizio.muscle_groups || "-"}</td>
          </tr>
          <tr>
            <th>Assetto</th>
            <td>{getNameFromValue(assetti, esercizio.posture)}</td>
          </tr>
          <tr>
            <th>Funzione complessa</th>
            <td>{esercizio.complex_function || "-"}</td>
          </tr>
          <tr>
            <th>Attrezzi</th>
            <td>{esercizio.equipment || "-"}</td>
          </tr>
          <tr>
            <th>Raccomandato per</th>
            <td>{esercizio.recommended_for || "-"}</td>
          </tr>
          <tr>
            <th>Controindicato per</th>
            <td>{esercizio.contraindicated_for || "-"}</td>
          </tr>
          {esercizio.type === "Exercise" && <>
            <tr>
              <th>Complessità gestione gravitaria</th>
              <td><div className="time-badge">{esercizio.gravity_management_complexity ?? "-"}</div></td>
            </tr>
            <tr>
              <th>Complessità coordinazione motoria</th>
              <td><div className="time-badge">{esercizio.motor_coordination_complexity ?? "-"}</div></td>
            </tr>
            <tr>
              <th>Intensità cardio-respiratoria</th>
              <td><div className="time-badge">{esercizio.cardiorespiratory_complexity ?? "-"}</div></td>
            </tr>
          </>
          }
          <tr>
            <th>Reminder</th>
            <td>{(esercizio.reminders.length || [])}</td>
          </tr>
        </>}
        {esercizio.type == "SpotEducativo" && <>
          <tr>
            <th>Categoria</th>
            <td>{esercizio.category ?? "-"}</td>
          </tr>
        </>}
      </tbody>
    </table >
  );
}
